import { get } from "lodash";
import AdUnit from "./adUnit";
import Site from "./site";

export default class Newsletter {
  id?: string;
  name: string;
  templateId: string;
  siteId: string;
  site?: Site;
  sections: NewsletterSection[];
  // adUnitIds: string[];
  // adUnits?: AdUnit[];

  constructor(params?: Newsletter) {
    this.id = get(params, "id");
    this.name = get(params, "name", "");
    this.templateId = get(params, "templateId", "");

    const siteId = get(params, "site.id", "");
    this.siteId = get(params, "siteId", siteId);
    this.sections = get(params, "sections", []);
    // const adUnitIds = get(params, "adUnits", []) as AdUnit[];
    // this.adUnitIds = get(
    //   params,
    //   "adUnitIds",
    //   adUnitIds.map((i) => i.id as string)
    // );
  }
}

export interface NewsletterSection {
  key: string;
  adUnitId: string;
}
